import { IContentSource } from "../../domain/drawing";

export abstract class AbstractSource implements IContentSource {
  constructor(protected _getToken: () => string) {
  }

  protected get token(): string {
    const token = this._getToken();
    if (AbstractSource.isEmpty(token)) {
      throw new Error("token is empty!!!");
    }
    return token;
  }

  protected static isEmpty(value: string) {
    return (value === undefined)
        || (value === null)
        || (value === "");
  }

  public get source(): string {
    return AbstractSource.toApplicationSource(this.getSource());
  }

  private static toApplicationSource(source: string): string {
    if (!source || source.length === 0) {
      return source;
    }
    return source.substring(0, 1) === "/"
      ? process.env.ASSET_PATH + source.substring(1)
      : process.env.ASSET_PATH + source;
  }

  protected abstract getSource(): string;

  public abstract clone(): IContentSource;
}
